export const parseTelefone = (v: string, ddd: string = "??"): string => {
  if (!v) return v;

  let telefone = v.replace(/[^0-9]+/g, "").replace("55", "");
  if (telefone[0] === "0") telefone = telefone.slice(1);
  if (telefone.length === 8 && ["9", "8"].includes(telefone[0]))
    telefone = "9" + telefone;
  if (telefone.length === 9) telefone = ddd + telefone;
  if (telefone.length === 10 && ["9", "8"].includes(telefone[2]))
    telefone = telefone.slice(0, 2) + "9" + telefone.slice(2);
  if (telefone.length === 11 && !["9", "8"].includes(telefone[3]))
    telefone = telefone.slice(0, 2) + telefone.slice(3);
  if (telefone.length === 11 && telefone[2] !== "9")
    telefone = telefone.slice(0, 2) + "9" + telefone.slice(3);

  return telefone.replace(/(\d{2})(\d{4,5})(\d{4})/, "($1) $2-$3");
};

export const parseTelefoneZap = (v: string, ddd: string = "??"): string => {
  if (!v) return v;

  let telefone = v.replace(/[^0-9]+/g, "").replace("55", "");
  if (telefone[0] === "0") telefone = telefone.slice(1);
  if (telefone.length === 8 || telefone.length === 9) telefone = ddd + telefone;
  if (telefone.length === 11)
    telefone = telefone.slice(0, 2) + telefone.slice(3);

  return `55` + telefone;
};

// Delimitador + campo entre aspas (com "" escapado) ou campo cru. Todo match
// consome o delimitador, então nunca é vazio (match vazio não avança o
// lastIndex → loop infinito). `(?:""|[^"])*` não tem quantificador aninhado:
// aspa sem fechar falha em tempo linear.
const regexCsvLineParser = /[,;\t\n](?=.)(?:"((?:""|[^"])*)"|([^",;\t\n]*))/g;

/** Separa uma linha de CSV (`,` `;` ou tab) nos valores crus de cada coluna. */
export const splitCsvLine = (line: string): string[] => {
  const valores: string[] = [];
  const linha = "\n" + line; // o 1º campo também passa a começar com delimitador
  regexCsvLineParser.lastIndex = 0;
  let m;
  while ((m = regexCsvLineParser.exec(linha)) !== null) {
    valores.push(m[2] ?? m[1]);
  }
  return valores;
};

export const isValidCPF = (cpf: string): boolean => {
  if (typeof cpf !== "string") return false;
  const digits = cpf.replace(/[^\d]+/g, "");
  if (digits.length !== 11 || !!digits.match(/(\d)\1{10}/)) return false;
  const nums = digits.split("").map((el) => +el);
  const rest = (count: number) =>
    ((nums
      .slice(0, count - 12)
      .reduce((soma, el, index) => soma + el * (count - index), 0) *
      10) %
      11) %
    10;
  return rest(10) === nums[9] && rest(11) === nums[10];
};

export const isValidCNPJ = (cnpj: string): boolean => {
  if (typeof cnpj !== "string") return false;
  const digits = cnpj.replace(/[^\d]+/g, "");
  if (digits.length !== 14 || !!digits.match(/(\d)\1{13}/)) return false;

  const b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const nums = digits.split("").map((el) => +el);
  let n = 0;
  for (let i = 0; i < 12; n += nums[i] * b[++i]);
  if (nums[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  n = 0;
  for (let i = 0; i <= 12; n += nums[i] * b[i++]);
  if (nums[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  return true;
};

export const formatSeconds = (value: number) => {
  const hours = Math.floor((value / 3600) % 24);
  const minutes = Math.floor((value % 3600) / 60);
  const seconds = value % 60;

  const days = Math.floor(value / 3600 / 24);
  return `${days > 0 ? `${days}d ` : ""}${hours}h ${days == 0 ? `${minutes}m ` : ""}${days == 0 ? `${seconds}s` : ""}`;
};
